/**
 * 审计页面
 */
import React, { Component } from 'react';
import { Card, CardBlock, Row, Col } from 'reactstrap';

export default class Audit extends Component {
  reader() {
    return (
      <Card>
        <CardBlock>
          <Row>
            <Col>
              {''}
            </Col>
          </Row>
        </CardBlock>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/App/Audit/index.js